import axios from 'axios';
import _ from 'lodash';
import baseUrl from './road';
import apis from './apis';
import {createUuidGenerator} from "@bhkk/fingerprint-generator";
import {getCookie} from "@/helper/dom";
import JsonBig from 'json-bigint';
const methods = ['get', 'post', 'delete', 'put', 'patch'];
import router from '../router'
export const [get, post, del, put, patch] = methods.map(  action => {

  return async val => {
    const url = reqRoad(val.road, val.data, val.version);
    const api = axios.create({ timeout: 10000 });
    //生成uuid的方法，开发环境下不会更新uuid。
    const uuidGenerator = await createUuidGenerator('production')
    return new Promise((resolve, reject) => {
      api.interceptors.request.use( config => {
        //生成指纹。生成出来的指纹会被存放到cookie里，由于异步生成，因此本次请求用到的指纹有可能是上一次请求生成的
        uuidGenerator();
        const { target } = getCookie("bhFingerprint", undefined);
        config.headers.common["appId"] = 10;
        config.headers.common["Browser-Uuid"] = target;
        return config
      })
      // debugger
      api.request({
        timeout: 10000,
        method: action,
        url,
        params: action === 'get' ? val.params : null,
        data: action !== 'get' ? val.params : null,
        transformResponse: [
          data => {
            return JSON.parse(JSON.stringify(JsonBig({ storeAsString: true }).parse(data)))
          }
        ]
      }).then(res => { resolve(res.data) }).catch((err) => {
        reject({
          code: _.get(err, 'response.status'),
          response: _.get(err, 'response.data')
        });
        const response = _.get(err, 'response.data');
        if (response.code === 90000012) {
          router.push('/banned')
        }
      });
    });
  };

});

const parseUrl = (url, params) => {
  return (
    url &&
    url.replace(/\{(\w+)\}/g, (m, n) => {
      return params[n];
    })
  );
};

export const serialize = function (obj) {
  const str = [];
  for (const p in obj)
    if (obj.hasOwnProperty(p) && obj[p]) {
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
    }
  return str.join('&');
};

const reqRoad = (road, data, version) => baseUrl[version] + parseUrl(apis[road], data);
